<template>
<div id="app" class="app-content mb-4">
  <loading :active.sync="isLoading" 
        :can-cancel="false" 
		:is-full-page="true"></loading>
    <app-header></app-header>
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 text-center">
            <div class="amej-title">
                <h1>Load PayUMoeny</h1>
            </div>
            </div>
        </div>
    </div>
  
    <div class="row">
        <div class="col-lg-8 col-md-8 offset-md-2">
          
          <b-alert
            :show="dismissCountDown1"
            dismissible
            variant="danger"
            @dismissed="dismissCountDown=0"
            @dismiss-count-down="countDownChanged"
          >
            <p>Fund load fail, Please Check your Card Details</p>
            <b-progress variant="success" :max="dismissSecs" :value="dismissCountDown" height="2px"></b-progress>
          </b-alert>

          <b-alert
            :show="dismissCountDown"
            dismissible
            variant="success"
            @dismissed="dismissCountDown=0"
            @dismiss-count-down="countDownChanged"
          >
            <p>Fund loaded Successfully</p>
            <b-progress variant="success" :max="dismissSecs" :value="dismissCountDown" height="2px"></b-progress>
          </b-alert>

          <b-form @submit.prevent id="2c2p-payment-form" name="paymentRequestForm">
            
            <b-form-group label-for="load-amount">
            <span class="text-danger pr-1">*</span>Enter the Amount to load
              <b-form-input
                id="load-amount"
                type="number"
                steps="0.01"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                v-model="loadfund_amount"
                placeholder="Enter the Amount to load"
              ></b-form-input>

              <span
                class="text-danger float-right"
                v-if="errors.loadfund_amount"
              >{{ errors.loadfund_amount}}</span>
            </b-form-group>

            <b-button
              type="submit"
              variant="amej-button"
              value="Checkout"
              @click="handleLoadFundForm"
            >Load Fund</b-button>
          </b-form>

          <form action="https://secure.payu.in/_payment" name="payuform" method=POST >
            <input type="hidden" name="key" v-model="payuform.key" />
            <input type="hidden" name="hash" v-model="payuform.hash"  />
            <input type="hidden" name="txnid" v-model="payuform.txnid" />
            <input type="hidden" name="amount" v-model="payuform.amount" />
            <input type="hidden" name="firstname" v-model="payuform.firstname" />
            <input type="hidden" name="email" v-model="payuform.email" />
            <input type="hidden" name="phone" v-model="payuform.phone" />
            <input type="hidden" name="productinfo" v-model="payuform.productinfo" />
            <input type="hidden" name="surl" v-model="payuform.surl" />
            <input type="hidden" name="furl" v-model="payuform.furl" />
            <input type="hidden" name="service_provider" value="" />
          </form>
        </div>
      </div>

</div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapState, mapActions } from "vuex";
import AppHeader from "../reuseable_components/Header.vue";
var sha512 = require('js-sha512').sha512;

export default  {
    name: "loadpayu",
    components: {
        "app-header": AppHeader,
        Loading,
    },
    data(){
        return{
            isLoading: false,
            dismissSecs: 3,
            dismissCountDown: 0,
            dismissCountDown1: 0,
            showDismissibleAlert: false,
            countDownChanged: 0,
            loadfund_amount: '',
            loadfund_reason: '',
            payuform: {
                key: '',
                hash: '',
                txnid: '',
                amount: '',
                firstname: '',
                email: '',
                phone: '',
                productinfo: '',
                surl: '',
                furl: '',
                service_provider: '',
            },
            errors: [],
        }
    },
    computed: {
        ...mapState([
        "message",
        "successmessage",
        "errormessage",
        "cardloaderrormessage",
        "profile",
        "payuHash"
        ]),
    },
    created(){
      this.listProfile();
    },
    methods: {
      ...mapActions(["listProfile"]),
      rndStr(len) {
        let text = ""
        let chars = "1234567890abcdefghijklmnopqrstuvwxyz"
        for( let i=0; i < len; i++ ) {
          text += chars.charAt(Math.floor(Math.random() * 35))
        }
        return text
      },
      handleLoadFundForm(){
          //
          this.errors = []
          if(this.loadfund_amount == ''){
              this.errors['loadfund_amount'] = "Amount required."
          }else if(parseFloat(this.loadfund_amount) <= 0){
              this.errors['loadfund_amount'] = "Amount must greater than 0."
          }else{
              this.isLoading = true

              // get all required value
              let merchantkey = process.env.VUE_APP_PAYU_MERCHANT
              let salt = process.env.VUE_APP_PAYU_SALT
              let txnid = this.rndStr(32)
              let name = this.profile.author && this.profile.author.first_name ? this.profile.author.first_name : 'Sunil'
              let email = this.profile.author && this.profile.author.email ? this.profile.author.email : 'cm@amejman.com'
              let amount = this.loadfund_amount
              let phone = this.profile.author && this.profile.author.phone ? this.profile.author.phone.substring(4,13) :  '9311611977'
              let surl = process.env.VUE_APP_SUCCESS_URL
              let furl = process.env.VUE_APP_FAIL_URL
              let productInfo = "loadfund"

              // Store some data in local
              let payuFormData = {
                'merchantkey': merchantkey,
                'salt': salt,
                'txnid': txnid,
                'name': name,
                'email': email,
                'phone': phone,
                'amount': amount,
                'surl': surl,
                'furl': furl
              }
              localStorage.setItem('payuFormData', JSON.stringify(payuFormData));
              
              // Send value to payu
              let hashValue = sha512(merchantkey+'|'+txnid+'|'+amount+'|'+productInfo+'|'+name+'|'+email+'|||||||||||'+salt)
              this.payuform.key = merchantkey
              this.payuform.hash = hashValue
              this.payuform.txnid = txnid
              this.payuform.amount = amount
              this.payuform.firstname = name
              this.payuform.email = email
              this.payuform.phone = phone
              this.payuform.productinfo = productInfo
              this.payuform.surl = surl
              this.payuform.furl = furl
              
              setTimeout(() => {
                  document.payuform.submit();
              }, 500);

              // this.payuform.key = 'wpvo74rH'
              // this.payuform.hash = 'a4e1c383fb4c498afdf363a4a1e7bafd032f65b871b0ee35ffae7693c88da412bdab48ba12d0bcd2597cbc1f5f0857b6f6fbce1592b5ca3063cc6c8a743e3098'
              // this.payuform.txnid = 'c0f3056a3dba4c989512'
              // this.payuform.amount = 5000.0
              // this.payuform.firstname = 'amejpay'
              // this.payuform.email = 'ramesh@gmail.com'
              // this.payuform.phone = 'null'
              // this.payuform.productinfo = 'loadfund'
              // this.payuform.surl = 'http://localhost:8080/app/payou/success'
              // this.payuform.furl = 'http://localhost:8080/app/payou/fail'
              // setTimeout(() => {
              //     document.payuform.submit();
              // }, 200);

              // Send value to get hash
              // let formDataHash = new FormData();
              // formDataHash.append("amount", this.loadfund_amount)
              // this.$store.dispatch("generatePayuHash", formDataHash).then(() => {
              //     if (this.successmessage == "success") {
              //         console.log("Hash: ",this.payuHash)
              //         // this.payuform.key = this.payuHash.key
              //         // this.payuform.hash = this.payuHash.hash_key
              //         // this.payuform.txnid = this.payuHash.txnid
              //         // this.payuform.amount = this.payuHash.amount
              //         // this.payuform.firstname = this.payuHash.firstname
              //         // this.payuform.email = this.payuHash.email
              //         // this.payuform.phone = this.payuHash.phone
              //         // this.payuform.productinfo = this.payuHash.productinfo
              //         // this.payuform.surl = this.payuHash.surl
              //         // this.payuform.furl = this.payuHash.furl
              //         // this.payuform.service_provider = ''
              //         // setTimeout(() => {
              //         //     document.payuform.submit();
              //         // }, 200);
              //     } else{
              //         console.log("Sorry!!!")
              //     }
              // });
          }
      }
    },
}
</script>
